import React, { useState, useMemo } from 'react';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import { Paper, Tooltip, IconButton, Typography } from '@material-ui/core';
import { BackButton, localization, getDimensionsOfPagination } from '../../sc-utilities';
import { Refresh } from '@material-ui/icons';
import MaterialTable from 'material-table';
import { parseURL } from '../../sc-utilities';
import * as actions from './store/deliveryNotesAction';
import * as action from '../../np-core/Auth/store/authActions';
import moment from 'moment';

const styles = theme => ({
    "@global": {
        "[class*='MuiTableCell-root MuiTableCell-body']": {
            maxHeight: "40px",
            minHeight: "40px",
            padding: '2px',
            fontSize: '0.7rem'
        },
    },
    customToolbar: {
        marginLeft: 14,
        width: "900px"
    },
    tableTitle: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        overflow: 'visible',
        marginTop: 'px'

    },
    customTooltip: {
        marginLeft: -16,
        marginTop: '-2px'
    }
});

let pageSize = 100;
let rowsPageSizeInit = [20, 50, 100];

const DeliveryNotesList = props => {
    const { classes, translations, onFetchDeliveryNotesCount, onFetchDeliveryNotes, fetching, saveColumnsFilter, activeCustomerID, tableColumns, tableRef } = props;
   
    const columnObject = useMemo(() => tableColumns
        // eslint-disable-next-line react-hooks/exhaustive-deps
        , []);
    const [tableOptions, setTableOptions] = useState({
        filtering: true,
        sorting: false,
        selection: false,
        search: false,
        minBodyHeight: window.innerHeight - 293 < 300 ? 300 : window.innerHeight - 293,
        maxBodyHeight: window.innerHeight - 293,
        pageSizeOptions: rowsPageSizeInit,
        exportButton: false,
        rowStyle: (_rowData, index) => {
            return { backgroundColor: index % 2 ? '#f3f3f3' : '#ffffff' };
        },
        columnsButton: true,
        pageSize: pageSize ? pageSize : 50,
        emptyRowsWhenPaging: false
    });

    const filterQuery = filters => {
        let obj = { ...parseURL(window.location.href) };
        for (var filter of filters) {
            obj[filter.column.field] = filter.value;
        }
        return obj;
    }

    async function fetchTableData(query) {
        let q = filterQuery(query.filters);
        q['CreatedAt'] = q['BilledDate'] ? moment(q['BilledDate']).set({ hour: 0, minute: 0, second: 0 }).format('YYYY-MM-DD HH:mm:ss') : null;
        query['ActiveCustomerID'] = activeCustomerID;
        query['q'] = q;
        let count = await onFetchDeliveryNotesCount(query);
        if (!query['page'] && query['pageSize'] !== 20 && query['pageSize'] !== 100) {
            let size = getDimensionsOfPagination(count);
            query['pageSize'] = size.pageSize;
            rowsPageSizeInit = size.rowsPageSize;
            pageSize = size.pageSize;
        }
        let result = count ? await onFetchDeliveryNotes(query) : [];
        setTableOptions({ ...tableOptions, pageSize: query['pageSize'], pageSizeOptions: rowsPageSizeInit });
        return { data: result, page: query.page, pageSize: pageSize, totalCount: count };
    }
  
    const tableTitle = () => {
        return <div className={classes.customToolbar}>
            <div className={classes.tableTitle}>
                {BackButton(translations, classes.customTooltip)}
                <Typography className={classes.typography}>{translations["delivery_notes"] || 'Delivery notes'}</Typography>

                <Tooltip title={translations["refresh"] || "Refresh"}>
                    <IconButton aria-label={translations["refresh"] || "Refresh"} component="div" disabled={fetching} onClick={() => tableRef.current && tableRef.current.onQueryChange()}>
                        <Refresh />
                    </IconButton>
                </Tooltip>
            </div>
        </div>
    }

    const columnHidden = newColumnState => {
        let objToSendColumn = {}
        let objColumns = {}
        columnObject.map(column => {
            objColumns[`${column.field}`] = column.hidden
            return objColumns
        })
        objToSendColumn[`DeliveryNotes`] = objColumns
        saveColumnsFilter({ ...objToSendColumn, ActiveCustomerID: activeCustomerID })
        return newColumnState
    }

    return (
        <Paper>
            <MaterialTable
                localization={localization(translations)}
                tableRef={tableRef}
                title={tableTitle()}
                columns={columnObject}
                data={fetchTableData}
                options={tableOptions}
                isLoading={fetching}
                onChangeRowsPerPage={(size) => {
                    pageSize = size
                }}
                onChangeColumnHidden={columnHidden}
                onChangePage={() => {if(tableRef?.current?.tableContainerDiv?.current) {tableRef.current.tableContainerDiv.current.scrollTop = 0}}}
            />
        </Paper>
    );
};

const mapStateToProps = state => {
    return {
        activeCustomerID: state.core.login.activeCustomer.CustomerID,
        translations: state.translate && state.translate.translations ? state.translate.translations.activeTranslations || {} : {},
        fetching: state.admin.deliveryNotes.fetching,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onFetchDeliveryNotesCount: filter => dispatch(actions.fetchDeliveryNotesCount(filter)),
        onFetchDeliveryNotes: filter => dispatch(actions.fetchDeliveryNotes(filter)),
        saveColumnsFilter: data => dispatch(action.saveColumnsFilter(data)),
    }
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles, { withTheme: true })(DeliveryNotesList));